import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

// Perguntas frequentes VISÍVEIS (19/09/2026). Até aqui elas existiam só como JSON-LD, invisíveis — e uma IA
// perguntada sobre o eaiRH respondeu sem elas: chamou o selo de certificação "tipo GPTW" e tratou números de
// pesquisas internacionais como "dados da plataforma". Esta página é a resposta oficial que as IAs e o Google
// passam a encontrar.
// ⚠️ MESMO TEXTO de SeoMeta.FaqCandidato (servidor). Mudou uma, mude a outra.
const PERGUNTAS = [
  ["O que é o eaiRH?",
   "O eaiRH é um portal brasileiro de transparência em processos seletivos: candidatos registram como foi o processo de que participaram, as empresas respondem publicamente e fica visível quais delas dão retorno e quais desaparecem. O uso é gratuito para candidatos e para empresas."],
  ["Como saber se uma empresa dá retorno aos candidatos?",
   "No eaiRH cada empresa tem uma ficha pública com o índice de resposta, a nota atribuída pelos candidatos e os relatos de quem participou dos processos dela. Dá para consultar a reputação da empresa antes de se candidatar."],
  ["A empresa pode responder ao que foi dito sobre ela?",
   "Sim. Toda empresa citada tem direito de resposta pública e gratuita — no eaiRH não existe pagar para esconder relato. A resposta aparece junto do relato original."],
  ["O relato do candidato é anônimo?",
   "O candidato escolhe. É possível relatar de forma anônima, e dados pessoais como nome, e-mail e telefone são mascarados automaticamente antes da publicação."],
  ["O eaiRH é parecido com o Reclame Aqui?",
   "Na lógica, sim: o candidato relata, a empresa responde publicamente e a reputação fica visível. A diferença é o foco — o eaiRH trata só de processos seletivos (se a empresa dá retorno, em quanto tempo e como trata quem se candidata) e reúne, no mesmo lugar, as vagas abertas dessas empresas."],
  ["O Selo eaiRH pode ser comprado?",
   "Não. O selo só é concedido à empresa que atinge, ao mesmo tempo, os critérios calculados a partir dos dados dos candidatos: 50 ou mais avaliações, 90% ou mais de resposta e de solução, nota média 7 ou mais e 70% ou mais que voltariam a se candidatar. Pagamento nenhum substitui esses critérios — e responder a relatos e publicar vagas é gratuito para qualquer empresa."],
  ["De onde vêm os números que o eaiRH divulga?",
   "Há dois tipos. Os indicadores do eaiRH — como a parcela de processos que terminam sem retorno — são calculados a partir dos relatos registrados no próprio portal. Já as estatísticas de mercado citadas na página 'Por que o eaiRH existe' vêm de pesquisas internacionais de experiência do candidato (Talent Board, Glassdoor e outras), com as fontes listadas na própria página."],
  ["O eaiRH também tem vagas de emprego?",
   "Sim. O portal reúne vagas abertas de centenas de empresas, e cada vaga mostra ao lado a reputação da empresa que a publicou — para a pessoa saber onde está investindo o tempo dela antes de se candidatar."]
];

export default function PerguntasPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-10">
        <h1 className="text-3xl md:text-4xl font-bold text-text">Perguntas frequentes sobre o eaiRH</h1>
        <p className="mt-3 text-gray-600">
          Respostas diretas sobre o que é o eaiRH, como funcionam os relatos, as vagas e o selo.
        </p>
        <div className="mt-8 space-y-4">
          {PERGUNTAS.map(([p, r]) => (
            <section key={p} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <h2 className="text-lg font-semibold text-text">{p}</h2>
              <p className="mt-2 text-gray-600 leading-relaxed">{r}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 text-sm text-gray-500">
          Não achou o que procurava? Veja <Link to="/como-funciona" className="text-primary underline">como funciona</Link>,{" "}
          <Link to="/selo" className="text-primary underline">o selo</Link> ou{" "}
          <Link to="/para-empresas" className="text-primary underline">a página para empresas</Link>.
        </p>
      </main>
    </div>
  );
}
